module.exports = __webpack_public_path__ + "static/media/camera.40701783.svg";